import SettingsToggle from '../../controls/settings-toggle';
import { ESettingsAdvancedWidgetLabels } from '../../settings.types';

interface PageTranslationsDetailProps {
  isEditing: boolean;
  disabled?: boolean;
  onToggle: (_key: string, on: boolean) => void;
}

const PageTranslationsDetail = ({ isEditing, disabled = false, onToggle }: PageTranslationsDetailProps) => {
  return (
    <SettingsToggle
      label={ESettingsAdvancedWidgetLabels.PAGE_TRANSLATIONS}
      value={isEditing}
      sKey="pageTranslations"
      disabled={disabled}
      onToggle={onToggle}
    />
  );
};

export default PageTranslationsDetail;
